import { OfferTitle } from './offer-title.component';

export type ExternalOfferTitleProps = {
  title: string;
  titleMiddle?: string | null;
  title2?: string | null;
};

export const ExternalOfferTitle = ({ title, titleMiddle, title2 }: ExternalOfferTitleProps) => {
  return (
    <OfferTitle variant="carousel">
      {title} {titleMiddle} {title2}
    </OfferTitle>
  );
};
